function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "16.6px",
    height: "11.2px",
    viewBox: "0 0 16.6 11.2",
    style: {
      enableBackground: "new 0 0 16.6 11.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M0.2,4C0.1,3.9,0,3.6,0,3.5c0-0.2,0.1-0.4,0.2-0.6l1.1-1.1c0.3-0.3,0.8-0.3,1.1,0l0.1,0.1L7,6.6 c0.2,0.2,0.4,0.2,0.6,0L14,0.2h0.1c0.3-0.3,0.8-0.3,1.1,0l1.1,1.1c0.3,0.3,0.3,0.8,0,1.1L7.8,11c-0.2,0.2-0.3,0.2-0.6,0.2 c-0.2,0-0.4-0.1-0.6-0.2L0.4,4.3L0.2,4z M0.2,4"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.9951ba75.svg";
export { ForwardRef as ReactComponent };